import NotFoundScene from './NotFoundScene';

export default NotFoundScene;
